<template>
  <div
    class="circular-view-wrap">
    <div
      v-if="newList.length === 0"
      style="padding-top:60%; position: relative;">
      <div
        class="image-slot">
        <i
          class="el-icon-picture-outline"
          style="font-size:40px;"></i>
      </div>
    </div>

    <el-row v-else>
      <el-col
        v-for="(item,index) in newList"
        :key="index"
        :span="span">
        <video
          v-if="item.contentType === 6 && item.linkType === 0"
          :src="item.image"
          style="width: 100%;"></video>
        <el-image
          v-else
          style="width: 100%;"
          :style="{height: item.image ? 'auto' : '160px'}"
          :src="item.image"
          fit="cover"></el-image>
      </el-col>
    </el-row>
    <!-- <el-carousel
      v-else
      class="el-carousel-fix">
      <el-carousel-item
        v-for="(item,index) in newList"
        :key="index">
        <el-image
          style="width: 100%; height: 100%"
          :src="item.image"
          fit="cover"></el-image>
      </el-carousel-item>
    </el-carousel> -->
  </div>
</template>
<script>
export default {
  name: 'WeImageView',
  props: {
    imageView: {
      type: Object,
      default() {
        return {
          componentName: 'pictureadv',
          layoutType: 1,
          graphics: [],
          visible: false
        }
      }
    }
  },
  data() {
    return {
      // png1,
      // png2,
      // png3
    }
  },
  computed: {
    span() {
      return this.imageView.layoutType === 1 ? 24 : 12
    },
    newList() {
      return this.imageView.graphics.map(i => {
        return {
          ...i,
          image: i.linkType === 0 && i.contentType === 6 ? i.image : i.image[0] ? i.image[0].url : ''
        }
      })
    }
    // png() {
    //   return ({
    //     1: this.png1,
    //     2: this.png2,
    //     3: this.png3
    //   })[this.templateId]
    // }
  }
}
</script>
<style lang="stylus">
.circular-view-wrap {
  position: relative;

  .image-slot {
    position: absolute;
    left: 0;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    color: #909399;
  }

  .el-carousel-fix {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;

    .el-carousel__container {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
